import { PGRColorModel, PGRBreedModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class PGRService {
  private static baseUrl: string = '/api/pgr';
  static tags = {
    getColors: 'getColors',
    getBreeds: 'getBreeds',
  };

  static getColors = (
    options?: ServiceMethodOptions,
  ): Promise<PGRColorModel[]> => {
    return trackPromise(
      new Promise<PGRColorModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/colors`)
          .get<PGRColorModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('PGR Colors fetched.', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get PGR Colors.', options);
            reject(err);
          });
      }),
      this.tags.getColors,
    );
  };
  static getBreeds = (
    options?: ServiceMethodOptions,
  ): Promise<PGRBreedModel[]> => {
    return trackPromise(
      new Promise<PGRBreedModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/breeds`)
          .get<PGRBreedModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('PGR Breeds fetched.', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get PGR Breeds.', options);
            reject(err);
          });
      }),
      this.tags.getBreeds,
    );
  };
}
